import { TABLE_PAGINATION_SCREEN_WIDTH_RESPONSIVE } from './TablePagination.constants'

export function getIsTablePaginationResponsive({
  responsive = false,
  screenWidth,
}) {
  return responsive && screenWidth <= TABLE_PAGINATION_SCREEN_WIDTH_RESPONSIVE
}
